module.exports = __webpack_public_path__ + "media/images/quest_start-a26e55eb365b6420bb91154f9be4940d.png";